// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__LtEtj","title":"ConsentsPage_title__SrYrB"};